// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const UserGroup = {
  "ADMINS": "Admins",
  "EMPLOYERS": "Employers",
  "GLOBAL_PARTNERS": "GlobalPartners",
  "NATIONALS": "Nationals",
  "TEAM": "Team"
};

const ArchivedState = {
  "ACTIVE": "ACTIVE",
  "ARCHIVED": "ARCHIVED"
};

const S3Level = {
  "PRIVATE": "PRIVATE",
  "PROTECTED": "PROTECTED",
  "PUBLIC": "PUBLIC"
};

const UserStatus = {
  "UNCONFIRMED": "UNCONFIRMED",
  "CONFIRMED": "CONFIRMED",
  "ARCHIVED": "ARCHIVED",
  "COMPROMISED": "COMPROMISED",
  "UNKNOWN": "UNKNOWN",
  "RESET_REQUIRED": "RESET_REQUIRED",
  "FORCE_CHANGE_PASSWORD": "FORCE_CHANGE_PASSWORD"
};

const PersonType = {
  "EMPLOYER": "Employer",
  "FOREIGN_NATIONAL": "ForeignNational",
  "TEAM_MEMBER": "TeamMember"
};

const CompanyType = {
  "COMPANY": "Company"
};

const CompanyAddressType = {
  "HEADQUARTERS": "HEADQUARTERS",
  "SECONDARY": "SECONDARY"
};

const UnitType = {
  "APARTMENT": "APARTMENT",
  "SUITE": "SUITE",
  "FLOOR": "FLOOR"
};

const StateCode = {
  "AL": "AL",
  "AK": "AK",
  "AZ": "AZ",
  "AR": "AR",
  "CA": "CA",
  "CO": "CO",
  "CT": "CT",
  "DE": "DE",
  "DC": "DC",
  "FL": "FL",
  "GA": "GA",
  "HI": "HI",
  "ID": "ID",
  "IL": "IL",
  "IN": "IN",
  "IA": "IA",
  "KS": "KS",
  "KY": "KY",
  "LA": "LA",
  "ME": "ME",
  "MD": "MD",
  "MA": "MA",
  "MI": "MI",
  "MN": "MN",
  "MS": "MS",
  "MO": "MO",
  "MT": "MT",
  "NE": "NE",
  "NV": "NV",
  "NH": "NH",
  "NJ": "NJ",
  "NM": "NM",
  "NY": "NY",
  "NC": "NC",
  "ND": "ND",
  "OH": "OH",
  "OK": "OK",
  "OR": "OR",
  "PA": "PA",
  "RI": "RI",
  "SC": "SC",
  "SD": "SD",
  "TN": "TN",
  "TX": "TX",
  "UT": "UT",
  "VT": "VT",
  "VA": "VA",
  "WA": "WA",
  "WV": "WV",
  "WI": "WI",
  "WY": "WY"
};

const CountryCode = {
  "AD": "AD",
  "AE": "AE",
  "AF": "AF",
  "AG": "AG",
  "AI": "AI",
  "AL": "AL",
  "AM": "AM",
  "AN": "AN",
  "AO": "AO",
  "AQ": "AQ",
  "AR": "AR",
  "AS": "AS",
  "AT": "AT",
  "AU": "AU",
  "AW": "AW",
  "AX": "AX",
  "AZ": "AZ",
  "BA": "BA",
  "BB": "BB",
  "BD": "BD",
  "BE": "BE",
  "BF": "BF",
  "BG": "BG",
  "BH": "BH",
  "BI": "BI",
  "BJ": "BJ",
  "BL": "BL",
  "BM": "BM",
  "BN": "BN",
  "BO": "BO",
  "BQ": "BQ",
  "BR": "BR",
  "BS": "BS",
  "BT": "BT",
  "BV": "BV",
  "BW": "BW",
  "BY": "BY",
  "BZ": "BZ",
  "CA": "CA",
  "CC": "CC",
  "CD": "CD",
  "CF": "CF",
  "CG": "CG",
  "CH": "CH",
  "CI": "CI",
  "CK": "CK",
  "CL": "CL",
  "CM": "CM",
  "CN": "CN",
  "CO": "CO",
  "CR": "CR",
  "CU": "CU",
  "CV": "CV",
  "CW": "CW",
  "CX": "CX",
  "CY": "CY",
  "CZ": "CZ",
  "DE": "DE",
  "DJ": "DJ",
  "DK": "DK",
  "DM": "DM",
  "DO": "DO",
  "DZ": "DZ",
  "EC": "EC",
  "EE": "EE",
  "EG": "EG",
  "EH": "EH",
  "ER": "ER",
  "ES": "ES",
  "ET": "ET",
  "EU": "EU",
  "FI": "FI",
  "FJ": "FJ",
  "FK": "FK",
  "FM": "FM",
  "FO": "FO",
  "FR": "FR",
  "GA": "GA",
  "GB": "GB",
  "GD": "GD",
  "GE": "GE",
  "GF": "GF",
  "GG": "GG",
  "GH": "GH",
  "GI": "GI",
  "GL": "GL",
  "GM": "GM",
  "GN": "GN",
  "GP": "GP",
  "GQ": "GQ",
  "GR": "GR",
  "GS": "GS",
  "GT": "GT",
  "GU": "GU",
  "GW": "GW",
  "GY": "GY",
  "HK": "HK",
  "HM": "HM",
  "HN": "HN",
  "HR": "HR",
  "HT": "HT",
  "HU": "HU",
  "ID": "ID",
  "IE": "IE",
  "IL": "IL",
  "IM": "IM",
  "IN": "IN",
  "IO": "IO",
  "IQ": "IQ",
  "IR": "IR",
  "IS": "IS",
  "IT": "IT",
  "JE": "JE",
  "JM": "JM",
  "JO": "JO",
  "JP": "JP",
  "KE": "KE",
  "KG": "KG",
  "KH": "KH",
  "KI": "KI",
  "KM": "KM",
  "KN": "KN",
  "KP": "KP",
  "KR": "KR",
  "KW": "KW",
  "KY": "KY",
  "KZ": "KZ",
  "LA": "LA",
  "LB": "LB",
  "LC": "LC",
  "LI": "LI",
  "LK": "LK",
  "LR": "LR",
  "LS": "LS",
  "LT": "LT",
  "LU": "LU",
  "LV": "LV",
  "LY": "LY",
  "MA": "MA",
  "MC": "MC",
  "MD": "MD",
  "ME": "ME",
  "MF": "MF",
  "MG": "MG",
  "MH": "MH",
  "MK": "MK",
  "ML": "ML",
  "MM": "MM",
  "MN": "MN",
  "MO": "MO",
  "MP": "MP",
  "MQ": "MQ",
  "MR": "MR",
  "MS": "MS",
  "MT": "MT",
  "MU": "MU",
  "MV": "MV",
  "MW": "MW",
  "MX": "MX",
  "MY": "MY",
  "MZ": "MZ",
  "NA": "NA",
  "NC": "NC",
  "NE": "NE",
  "NF": "NF",
  "NG": "NG",
  "NI": "NI",
  "NL": "NL",
  "NO": "NO",
  "NP": "NP",
  "NR": "NR",
  "NU": "NU",
  "NZ": "NZ",
  "OM": "OM",
  "PA": "PA",
  "PE": "PE",
  "PF": "PF",
  "PG": "PG",
  "PH": "PH",
  "PK": "PK",
  "PL": "PL",
  "PM": "PM",
  "PN": "PN",
  "PR": "PR",
  "PS": "PS",
  "PT": "PT",
  "PW": "PW",
  "PY": "PY",
  "QA": "QA",
  "RE": "RE",
  "RO": "RO",
  "RS": "RS",
  "RU": "RU",
  "RW": "RW",
  "SA": "SA",
  "SB": "SB",
  "SC": "SC",
  "SD": "SD",
  "SE": "SE",
  "SG": "SG",
  "SH": "SH",
  "SI": "SI",
  "SJ": "SJ",
  "SK": "SK",
  "SL": "SL",
  "SM": "SM",
  "SN": "SN",
  "SO": "SO",
  "SR": "SR",
  "SS": "SS",
  "ST": "ST",
  "SV": "SV",
  "SX": "SX",
  "SY": "SY",
  "SZ": "SZ",
  "TC": "TC",
  "TD": "TD",
  "TF": "TF",
  "TG": "TG",
  "TH": "TH",
  "TJ": "TJ",
  "TK": "TK",
  "TL": "TL",
  "TM": "TM",
  "TN": "TN",
  "TO": "TO",
  "TR": "TR",
  "TT": "TT",
  "TV": "TV",
  "TW": "TW",
  "TZ": "TZ",
  "UA": "UA",
  "UG": "UG",
  "UM": "UM",
  "US": "US",
  "UY": "UY",
  "UZ": "UZ",
  "VA": "VA",
  "VI": "VI",
  "VC": "VC",
  "VE": "VE",
  "VG": "VG",
  "VN": "VN",
  "VU": "VU",
  "WF": "WF",
  "WS": "WS",
  "YE": "YE",
  "YT": "YT",
  "ZA": "ZA",
  "ZM": "ZM",
  "ZW": "ZW"
};

const MaritalStatus = {
  "UNMARRIED": "UNMARRIED",
  "MARRIED": "MARRIED",
  "DIVORCED": "DIVORCED",
  "WIDOWED": "WIDOWED"
};

const FamilyRelationshipType = {
  "AUNT_UNCLE": "AUNT_UNCLE",
  "CHILD": "CHILD",
  "CHILD_IN_LAW": "CHILD_IN_LAW",
  "CHILD_OF_GUARDIAN": "CHILD_OF_GUARDIAN",
  "COMMON_LAW_PARTNER": "COMMON_LAW_PARTNER",
  "COUSIN": "COUSIN",
  "FIANCE": "FIANCE",
  "GRANDCHILD": "GRANDCHILD",
  "GRANDPARENT": "GRANDPARENT",
  "GUARDIAN": "GUARDIAN",
  "LTDP": "LTDP",
  "NIECE_NEPHEW": "NIECE_NEPHEW",
  "PARENT": "PARENT",
  "PARENT_IN_LAW": "PARENT_IN_LAW",
  "PRIOR_LTDP": "PRIOR_LTDP",
  "SIBLING": "SIBLING",
  "SPOUSE": "SPOUSE",
  "SPOUSE_DECEASED": "SPOUSE_DECEASED",
  "SPOUSE_DIVORCED": "SPOUSE_DIVORCED",
  "PRIOR_SPOUSE_OF_DECEASED": "PRIOR_SPOUSE_OF_DECEASED",
  "STEP_CHILD": "STEP_CHILD",
  "STEP_PARENT": "STEP_PARENT"
};

const VisaStatus = {
  "B_1": "B_1",
  "E_1": "E_1",
  "E_2": "E_2",
  "H_1_B": "H_1B",
  "H_2_A": "H_2A",
  "H_1_B1": "H_1B1",
  "H_4": "H_4",
  "E_3": "E_3",
  "GLOBAL_PROCESS": "GLOBAL_PROCESS",
  "H_3": "H_3",
  "I": "I",
  "J_1": "J_1",
  "L_1": "L_1",
  "L_1_A": "L_1A",
  "L_1_B": "L_1B",
  "L_BLANKET": "L_BLANKET",
  "PERM_GREEN_CARD": "PERM_GREEN_CARD",
  "O_1": "O_1",
  "P_1": "P_1",
  "P_3": "P_3",
  "R_1": "R_1",
  "TN": "TN",
  "NOT_SURE": "NOT_SURE"
};

const EmploymentBasedCategory = {
  "EB_1": "EB_1",
  "EB_2": "EB_2",
  "EB_3": "EB_3",
  "EB_4": "EB_4",
  "EB_5_NON_REGIONAL_CENTER": "EB_5_NON_REGIONAL_CENTER",
  "EB_5_REGIONAL_CENTER": "EB_5_REGIONAL_CENTER",
  "EB_OTHER_WORKERS": "EB_OTHER_WORKERS",
  "EB_CERTAIN_RELIGIOUS_WORKERS": "EB_CERTAIN_RELIGIOUS_WORKERS",
  "EB_5_SET_ASIDE" : "EB_5_SET_ASIDE",
  "SPOUSE_OF_US_CITIZEN" : "SPOUSE_OF_US_CITIZEN",
  "PARENT_OF_US_CITIZEN" : "PARENT_OF_US_CITIZEN",
  "F_1" : "F_1",
  "F_2A" : "F_2A",
  "F_2B" : "F_2B",
  "F_3" : "F_3",
  "F_4" : "F_4",
  "REFUGEE_OR_ASYLEE" : "REFUGEE_OR_ASYLEE",
  "DIVERSITY" : "DIVERSITY",
  "SPECIAL_IMMIGRANT" : "SPECIAL_IMMIGRANT",
  "HUMAN_TRAFFICKING_AND_CRIME_VICTIM" : "HUMAN_TRAFFICKING_AND_CRIME_VICTIM",
  "VICTIM_OF_ABUSE" : "VICTIM_OF_ABUSE"
};

const JobDescriptionType = {
  "STANDARD": "STANDARD",
  "ONEOFF": "ONEOFF"
};

const Degree = {
  "NONE": "NONE",
  "BACHELORS": "BACHELORS",
  "MASTERS": "MASTERS",
  "PHD": "PHD"
};

const FileType = {
  "BIRTH_CERTIFICATE": "BIRTH_CERTIFICATE",
  "COMPANY_FINANCIAL_STATEMENT": "COMPANY_FINANCIAL_STATEMENT",
  "DIPLOMA": "DIPLOMA",
  "EAD_CARD": "EAD_CARD",
  "EDUCATION_EVALUATION": "EDUCATION_EVALUATION",
  "EXPERIENCE_LETTER": "EXPERIENCE_LETTER",
  "H_1_B_APPLICATION": "H_1B_APPLICATION",
  "H_4_APPLICATION": "H_4_APPLICATION",
  "I_140_APPROVAL_NOTICE": "I_140_APPROVAL_NOTICE",
  "I_20_COPY": "I_20_COPY",
  "I_797_APPROVAL_NOTICE": "I_797_APPROVAL_NOTICE",
  "I_94": "I_94",
  "JOB_DESCRIPTION": "JOB_DESCRIPTION",
  "MARKETING_MATERIAL": "MARKETING_MATERIAL",
  "MARRIAGE_CERTIFICATE": "MARRIAGE_CERTIFICATE",
  "MASTER_AGREEMENT": "MASTER_AGREEMENT",
  "OTHER": "OTHER",
  "PASSPORT": "PASSPORT",
  "PASSPORT_PHOTO": "PASSPORT_PHOTO",
  "PAY_STUBS": "PAY_STUBS",
  "PERM_APPLICATION": "PERM_APPLICATION",
  "PERM_SIGNATURE_PAGES": "PERM_SIGNATURE_PAGES",
  "PREVIOUS_I_140_APPROVAL_NOTICES": "PREVIOUS_I_140_APPROVAL_NOTICES",
  "PREVIOUS_I_797_APPROVAL_NOTICES": "PREVIOUS_I_797_APPROVAL_NOTICES",
  "PRIOR_EAD": "PRIOR_EAD",
  "RESUME": "RESUME",
  "COMPLETED_FORMS": "COMPLETED_FORMS",
  "SCHOOL_MARK_TRANSCRIPT": "SCHOOL_MARK_TRANSCRIPT",
  "SIGNED_EMPLOYMENT_CONTRACT": "SIGNED_EMPLOYMENT_CONTRACT",
  "SUPPORT_LETTER": "SUPPORT_LETTER",
  "VENDOR_CLIENT_LETTERS": "VENDOR_CLIENT_LETTERS",
  "VISA_STAMPS": "VISA_STAMPS",
  "W2": "W2",
  //Extra Documents
  "H_1_B_RECEIPT_NOTICE": "H_1B_RECEIPT_NOTICE",
  "H_1_B_SIGNATURE_PAGES": "H_1B_SIGNATURE_PAGES",
  "H_4_RECEIPT_NOTICE": "H_4_RECEIPT_NOTICE",
  "H_4_SIGNATURE_PAGES": "H_4_SIGNATURE_PAGES",
  //Perm Recruitment
  "CANDIDATE_RESUMES_AND_ASSESSMENTS":  "CANDIDATE_RESUMES_AND_ASSESSMENTS",
  "SIGNED_COPY_OF_NOTICE_OF_FILLING_NOF": "SIGNED_COPY_OF_NOTICE_OF_FILLING_NOF",
  "EMPLOYEE_REFERRAL_PROGRAM": "EMPLOYEE_REFERRAL_PROGRAM",
  "SUNDAY_NEWSPAPER_AD_1": "SUNDAY_NEWSPAPER_AD_1",
  "SUNDAY_NEWSPAPER_AD_2": "SUNDAY_NEWSPAPER_AD_2",
  "STATE_WORKFORCE_AGENCY_POSTING": "STATE_WORKFORCE_AGENCY_POSTING",
  "WEEKDAY_ETHNIC_NEWSPAPER_AD": "WEEKDAY_ETHNIC_NEWSPAPER_AD",
  "RADIO_AD": "RADIO_AD",
  "CAMPUS_PLACEMENT": "CAMPUS_PLACEMENT",
  "JOB_FAIR": "JOB_FAIR",
  "COMPANY_WEBSITE": "COMPANY_WEBSITE",
  "JOB_SEARCH_ENGINE": "JOB_SEARCH_ENGINE",
};

const Position = {
  "ATTORNEY": "ATTORNEY",
  "PARALEGAL": "PARALEGAL",
  "LEGAL_ASSISTANT": "LEGAL_ASSISTANT",
  "CONTRIBUTOR": "CONTRIBUTOR"
};

const CaseState = {
  "NA": "NA",
  "PENDING": "PENDING",
  "OPEN": "OPEN",
  "CLOSED": "CLOSED",
  "COMPLETED": "COMPLETED"
};

const ProcessRequestLocationType = {
  "HEADQUARTERS": "HEADQUARTERS",
  "SECONDARY": "SECONDARY",
  "REMOTE": "REMOTE"
};

const Currency = {
  "USD": "USD",
  "EUR": "EUR",
  "GBP": "GBP"
};

const VisaSubCategory = {
  "H_1_B_CHANGE_STATUS": "H_1B_CHANGE_STATUS",
  "H_1_B_EXTENSION": "H_1B_EXTENSION",
  "H_1_B_EXTENSION_SUBSEQUENT": "H_1B_EXTENSION_SUBSEQUENT",
  "H_1_B_AMENDMENT": "H_1B_AMENDMENT",
  "H_1_B_TRANSFER": "H_1B_TRANSFER",
  "H_1_B_CAP_LOTTERY": "H_1B_CAP_LOTTERY",
  "H_4_CHANGE_STATUS": "H_4_CHANGE_STATUS",
  "H_4_EXTENSION": "H_4_EXTENSION",
  "USCIS_PRIMARY_ADVANCE_PAROLE" : "USCIS_PRIMARY_ADVANCE_PAROLE",
  "USCIS_PRIMARY_B_1" : "USCIS_PRIMARY_B_1",
  "USCIS_PRIMARY_EB_1A" : "USCIS_PRIMARY_EB_1A",
  "USCIS_PRIMARY_EB_1B" : "USCIS_PRIMARY_EB_1B",
  "USCIS_PRIMARY_EB_1C" : "USCIS_PRIMARY_EB_1C",
  "USCIS_PRIMARY_E_1" : "USCIS_PRIMARY_E_1",
  "USCIS_PRIMARY_E_2" : "USCIS_PRIMARY_E_2",
  "USCIS_PRIMARY_H_3" : "USCIS_PRIMARY_H_3",
  "USCIS_PRIMARY_I" : "USCIS_PRIMARY_I",
  "USCIS_PRIMARY_INTERNATIONAL_ENTREPRENEUR_PAROLE" : "USCIS_PRIMARY_INTERNATIONAL_ENTREPRENEUR_PAROLE",
  "USCIS_PRIMARY_I_485J" : "USCIS_PRIMARY_I_485J",
  "USCIS_PRIMARY_I_140": "USCIS_PRIMARY_I_140",
  "USCIS_PRIMARY_J_1" : "USCIS_PRIMARY_J_1",
  "USCIS_PRIMARY_L_BLANKET": "USCIS_PRIMARY_L_BLANKET",
  "USCIS_PRIMARY_L_1A": "USCIS_PRIMARY_L_1A",
  "USCIS_PRIMARY_L_1B": "USCIS_PRIMARY_L_1B",
  "USCIS_PRIMARY_NATIONAL_INTEREST_WAIVER" : "USCIS_PRIMARY_NATIONAL_INTEREST_WAIVER",
  "USCIS_PRIMARY_N_400" : "USCIS_PRIMARY_N_400",
  "USCIS_PRIMARY_O_1" : "USCIS_PRIMARY_O_1",
  "USCIS_PRIMARY_O_2" : "USCIS_PRIMARY_O_2",
  "USCIS_PRIMARY_P_1" : "USCIS_PRIMARY_P_1",
  "USCIS_PRIMARY_P_3" : "USCIS_PRIMARY_P_3",
  "USCIS_PRIMARY_Q_1" : "USCIS_PRIMARY_Q_1",
  "USCIS_PRIMARY_R_1" : "USCIS_PRIMARY_R_1",
  "USCIS_PRIMARY_RE_ENTRY_PERMIT" : "USCIS_PRIMARY_RE_ENTRY_PERMIT",
  "USCIS_PRIMARY_SCHEDULE_A_GREEN_CARD" : "USCIS_PRIMARY_SCHEDULE_A_GREEN_CARD",
  "USCIS_DEPENDENT_ADVANCE_PAROLE": "USCIS_DEPENDENT_ADVANCE_PAROLE",
  "USCIS_DEPENDENT_B_1": "USCIS_DEPENDENT_B_1",
  "USCIS_DEPENDENT_B_2": "USCIS_DEPENDENT_B_2",
  "USCIS_DEPENDENT_DACA": "USCIS_DEPENDENT_DACA",
  "USCIS_DEPENDENT_E_1_DEPENDENT": "USCIS_DEPENDENT_E_1_DEPENDENT",
  "USCIS_DEPENDENT_E_2_DEPENDENT": "USCIS_DEPENDENT_E_2_DEPENDENT",
  "USCIS_DEPENDENT_EB_5_INVESTOR_I_526": "USCIS_DEPENDENT_EB_5_INVESTOR_I_526",
  "USCIS_DEPENDENT_EB_5_INVESTOR_I_829": "USCIS_DEPENDENT_EB_5_INVESTOR_I_829",
  "USCIS_DEPENDENT_F_1": "USCIS_DEPENDENT_F_1",
  "USCIS_DEPENDENT_F_2": "USCIS_DEPENDENT_F_2",
  "USCIS_DEPENDENT_I_130": "USCIS_DEPENDENT_I_130",
  "USCIS_DEPENDENT_I_140": "USCIS_DEPENDENT_I_140",
  "USCIS_DEPENDENT_I_751": "USCIS_DEPENDENT_I_751",
  "USCIS_DEPENDENT_INTENATIONAL_ENTREPRENEUR_PAROLE_DEPENDENT": "USCIS_DEPENDENT_INTENATIONAL_ENTREPRENEUR_PAROLE_DEPENDENT",
  "USCIS_DEPENDENT_J_2": "USCIS_DEPENDENT_J_2",
  "USCIS_DEPENDENT_K_1": "USCIS_DEPENDENT_K_1",
  "USCIS_DEPENDENT_L_2": "USCIS_DEPENDENT_L_2",
  "USCIS_DEPENDENT_N_400_CITIZENSHIP": "USCIS_DEPENDENT_N_400_CITIZENSHIP",
  "USCIS_DEPENDENT_O_3": "USCIS_DEPENDENT_O_3",
  "USCIS_DEPENDENT_P_4": "USCIS_DEPENDENT_P_4",
  "USCIS_DEPENDENT_Q_2": "USCIS_DEPENDENT_Q_2",
  "USCIS_DEPENDENT_REENTRY_PERMIT": "USCIS_DEPENDENT_REENTRY_PERMIT",
  "USCIS_DEPENDENT_R_2": "USCIS_DEPENDENT_R_2",
  "USCIS_DEPENDENT_TEMPORARY_PROTECTED_STATUS": "USCIS_DEPENDENT_TEMPORARY_PROTECTED_STATUS",
  "H_1B_LOTTERY_CHANGE_OF_STATUS": "H_1B_LOTTERY_CHANGE_OF_STATUS",
  "H_1B_LOTTERY_CONSULAR_NOTIFICATION": "H_1B_LOTTERY_CONSULAR_NOTIFICATION",
  "H_1B_LOTTERY_MASTERS": "H_1B_LOTTERY_MASTERS",
  "H_1B_LOTTERY_24_CHANGE_OF_STATUS": "H_1B_LOTTERY_24_CHANGE_OF_STATUS",
  "H_1B_LOTTERY_24_CONSULAR_NOTIFICATION": "H_1B_LOTTERY_24_CONSULAR_NOTIFICATION",
  "EAD_PRIMARY": "EAD_PRIMARY",
  "USCIS_PRIMARY_2_ADVANCE_PAROLE": "USCIS_PRIMARY_2_ADVANCE_PAROLE",
  "USCIS_PRIMARY_2_B_1": "USCIS_PRIMARY_2_B_1",
  "USCIS_PRIMARY_2_B_2": "USCIS_PRIMARY_2_B_2",
  "USCIS_PRIMARY_2_CONSULAR_PROCESSING": "USCIS_PRIMARY_2_CONSULAR_PROCESSING",
  "USCIS_PRIMARY_2_EB_1A": "USCIS_PRIMARY_2_EB_1A",
  "USCIS_PRIMARY_2_F_1": "USCIS_PRIMARY_2_F_1",
  "USCIS_PRIMARY_2_I_130": "USCIS_PRIMARY_2_I_130",
  "USCIS_PRIMARY_2_K_1": "USCIS_PRIMARY_2_K_1",
  "USCIS_PRIMARY_2_I_485J": "USCIS_PRIMARY_2_I_485J",
  "USCIS_PRIMARY_2_NATIONAL_INTEREST_WAIVER": "USCIS_PRIMARY_2_NATIONAL_INTEREST_WAIVER",
  "USCIS_PRIMARY_2_N_400": "USCIS_PRIMARY_2_N_400",
  "USCIS_PRIMARY_2_O_1": "USCIS_PRIMARY_2_O_1",
  "USCIS_PRIMARY_2_RE_ENTRY_PERMIT": "USCIS_PRIMARY_2_RE_ENTRY_PERMIT",
  "USCIS_PRIMARY_2_U": "USCIS_PRIMARY_2_U",
};

const ProcessRequestState = {
  "REQUESTED": "REQUESTED",
  "APPROVED": "APPROVED",
  "ARCHIVED": "ARCHIVED"
};

const TaskCategory = {
  "OPENING_CASE": "OPENING_CASE",
  "LCA_FILING": "LCA_FILING",
  "PUBLIC_ACCESS_FILE": "PUBLIC_ACCESS_FILE",
  "PREPARING_MATERIALS": "PREPARING_MATERIALS",
  "APPLICATION_REVIEW": "APPLICATION_REVIEW",
  "SUBMITTING_APPLICATION": "SUBMITTING_APPLICATION",
  "RECEIPT_BY_GOVERNMENT": "RECEIPT_BY_GOVERNMENT",
  "PREMIUM_PROCESSING_UPGRADE": "PREMIUM_PROCESSING_UPGRADE",
  "REQUEST_FOR_EVIDENCE": "REQUEST_FOR_EVIDENCE",
  "FINAL_DECISION": "FINAL_DECISION"
};

const TaskState = {
  "LOCKED": "LOCKED",
  "TODO": "TODO",
  "COMPLETED": "COMPLETED",
  "DELETED": "DELETED"
};

const CasePhase = {
  "APPLICATION_SUBMISSION": "APPLICATION_SUBMISSION",
  "CASE_OPENING": "CASE_OPENING",
  "CASE_PREPARATION": "CASE_PREPARATION",
  "DATA_COLLECTION": "DATA_COLLECTION",
  "FILE_I140": "FILE_I140",
  "FILE_PREVAILING_WAGE_REQUEST": "FILE_PREVAILING_WAGE_REQUEST",
  "FINAL_DECISION": "FINAL_DECISION",
  "FORMS_PREPARATION": "FORMS_PREPARATION",
  "I140_PREPARATION": "I140_PREPARATION",
  "LCA_FILING": "LCA_FILING",
  "NEXT_STEPS": "NEXT_STEPS",
  "PERM_SUBMISSION": "PERM_SUBMISSION",
  "RECRUITMENT": "RECRUITMENT"
};

const CaseMilestone = {
  "APPLICATION_DECISION": "APPLICATION_DECISION",
  "APPLICATION_SHIPPED": "APPLICATION_SHIPPED",
  "APPROVAL_NOTICE_SHIPPED": "APPROVAL_NOTICE_SHIPPED",
  "CASE_OPENED": "CASE_OPENED",
  "DOCUMENTS_UPLOADED": "DOCUMENTS_UPLOADED",
  "EXPERIENCE_LETTERS_UPLOADED": "EXPERIENCE_LETTERS_UPLOADED",
  "FINAL_DECISION": "FINAL_DECISION",
  "FORMS_COMPLETED": "FORMS_COMPLETED",
  "FORMS_PREPARED": "FORMS_PREPARED",
  "I140_APPLICATION_SHIPPED": "I140_APPLICATION_SHIPPED",
  "I140_CASE_OPENING": "I140_CASE_OPENING",
  "I140_FORMS_PREPARED": "I140_FORMS_PREPARED",
  "I140_RECEIPT_NOTICE_RECEIVED": "I140_RECEIPT_NOTICE_RECEIVED",
  "JOB_DESCRIPTION_FINALIZED": "JOB_DESCRIPTION_FINALIZED",
  "LCA_FILED": "LCA_FILED",
  "LCA_RECEIVED": "LCA_RECEIVED",
  "NEXT_STEPS": "NEXT_STEPS",
  "PERM_CERTIFIED": "PERM_CERTIFIED",
  "PERM_PREPARED": "PERM_PREPARED",
  "PERM_REVIEWED": "PERM_REVIEWED",
  "PERM_SUBMITED": "PERM_SUBMITED",
  "PREVAILING_WAGE_DETERMINATION_RECEIVED": "PREVAILING_WAGE_DETERMINATION_RECEIVED",
  "PREVAILING_WAGE_REQUEST_FILED": "PREVAILING_WAGE_REQUEST_FILED",
  "QUESTIONNAIRE_COMPLETED": "QUESTIONNAIRE_COMPLETED",
  "RECEIPT_NOTICE_RECEIVED": "RECEIPT_NOTICE_RECEIVED",
  "RECRUITMENT_BEGUN": "RECRUITMENT_BEGUN",
  "RECRUITMENT_COMPLETE": "RECRUITMENT_COMPLETE"
};

const PreparedFormState = {
  "TODO": "TODO",
  "PREPARED": "PREPARED",
  "AWAITING_ATTORNEY_APPROVAL": "AWAITING_ATTORNEY_APPROVAL",
  "AWAITING_NATIONAL_APPROVAL": "AWAITING_NATIONAL_APPROVAL",
  "AWAITING_SPONSOR_APPROVAL": "AWAITING_SPONSOR_APPROVAL",
  "AWAITING_FINAL_APPROVAL": "AWAITING_FINAL_APPROVAL",
  "REJECTED": "REJECTED",
  "COMPLETED": "COMPLETED"
};

const ActivityType = {
  "DOCUMENT_EXPIRATION_INCOMING": "DOCUMENT_EXPIRATION_INCOMING",
  "DOCUMENT_UPLOADED": "DOCUMENT_UPLOADED",
  "DOCUMENT_UPLOAD_REQUESTED": "DOCUMENT_UPLOAD_REQUESTED",
  "DOCUMENT_TYPE_COMPLETED": "DOCUMENT_TYPE_COMPLETED",
  "PROCESS_REQUEST_SUBMITTED": "PROCESS_REQUEST_SUBMITTED",
  "PROCESS_REQUEST_REASSIGNED": "PROCESS_REQUEST_REASSIGNED",
  "PROCESS_REQUEST_ARCHIVED": "PROCESS_REQUEST_ARCHIVED",
  "PROCESS_REQUEST_APPROVED": "PROCESS_REQUEST_APPROVED",
  "PROCESS_REQUEST_RESUBMITTED": "PROCESS_REQUEST_RESUBMITTED",
  "CASE_COMMENT_ADDED": "CASE_COMMENT_ADDED",
  "CASE_MILESTONE_COMPLETED": "CASE_MILESTONE_COMPLETED",
  "CASE_MILESTONE_UNCOMPLETED": "CASE_MILESTONE_UNCOMPLETED",
  "CASE_MILESTONE_RECEIPT_NUMBER_CHANGED": "CASE_MILESTONE_RECEIPT_NUMBER_CHANGED",
  "CASE_FORM_PREPARED": "CASE_FORM_PREPARED",
  "CASE_FORM_REJECTED": "CASE_FORM_REJECTED",
  "CASE_FORM_RESET": "CASE_FORM_RESET",
  "CASE_FORM_REVIEW_REQUESTED": "CASE_FORM_REVIEW_REQUESTED",
  "CASE_FORM_APPROVED": "CASE_FORM_APPROVED",
  "CASE_FORM_COMPLETED": "CASE_FORM_COMPLETED",
  "CASE_TEAM_ATTORNEY_ADDED": "CASE_TEAM_ATTORNEY_ADDED",
  "CASE_TEAM_MANAGER_ADDED": "CASE_TEAM_MANAGER_ADDED",
  "CASE_TEAM_SPONSOR_ADDED": "CASE_TEAM_SPONSOR_ADDED",
  "CASE_TEAM_CONTRIBUTOR_ADDED": "CASE_TEAM_CONTRIBUTOR_ADDED",
  "CASE_COMPLETED": "CASE_COMPLETED",
  "CASE_CLOSED": "CASE_CLOSED",
  "CASE_REOPENED": "CASE_REOPENED",
  "LEGAL_TEAM_ATTORNEY_ADDED": "LEGAL_TEAM_ATTORNEY_ADDED",
  "LEGAL_TEAM_PARALEGAL_ADDED": "LEGAL_TEAM_PARALEGAL_ADDED",
  "LEGAL_TEAM_ACCOUNT_MANAGER_ADDED": "LEGAL_TEAM_ACCOUNT_MANAGER_ADDED",
  "PROFILE_QUESTIONNAIRE_COMPLETED": "PROFILE_QUESTIONNAIRE_COMPLETED",
  "COMPANY_QUESTIONNAIRE_COMPLETED": "COMPANY_QUESTIONNAIRE_COMPLETED",
  "PROFILE_CREATED": "PROFILE_CREATED",
  "RELATIVE_ADMIN_QUESTIONNAIRE_COMPLETED": "RELATIVE_ADMIN_QUESTIONNAIRE_COMPLETED",
  "COMPANY_PROFILE_UPDATED": "COMPANY_PROFILE_UPDATED",
  "PERSON_PROFILE_UPDATED": "PERSON_PROFILE_UPDATED",
  "CASE_DETAIL_UPDATED": "CASE_DETAIL_UPDATED",
  "FN_PROFILE_UPDATE_OPEN_CASE": "FN_PROFILE_UPDATE_OPEN_CASE",
  "FN_PROFILE_UPDATE_NO_OPEN_CASE": "FN_PROFILE_UPDATE_NO_OPEN_CASE",
  "COMPLETE_REPORT_MANUALLY": "COMPLETE_REPORT_MANUALLY",
  "REPORT_SENT_MANUALLY": "REPORT_SENT_MANUALLY",
  "USCIS_CASE_STATUS_UPDATED": "USCIS_CASE_STATUS_UPDATED",
};

const PassportGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE"
};

const ExpenseDependentPetitions = {
  "BOTH": "BOTH",
  "ONLY_DEPENDENT": "ONLY_DEPENDENT",
  "ONLY_EAD_CARDS": "ONLY_EAD_CARDS",
  "NO": "NO"
};

const EducationEvaluation = {
  "MH_SHOULD_GET": "MH_SHOULD_GET",
  "MH_SHOULD_REACH_OUT": "MH_SHOULD_REACH_OUT",
  "COMPANY_WILL_PROVIDE": "COMPANY_WILL_PROVIDE"
};

const EmployeesEmailContactDirectly = {
  "TRUE": "TRUE",
  "COMPANY_REPRESENTATIVE_COPIED": "COMPANY_REPRESENTATIVE_COPIED",
  "FALSE": "FALSE",
  "A_COMPANY_REPRESENTATIVE_SHOULD_BE_COPIED_ON_ALL_COMMUNICATION": "A_COMPANY_REPRESENTATIVE_SHOULD_BE_COPIED_ON_ALL_COMMUNICATION",
  "A_COMPANY_REPRESENTATIVE_WILL_ONLY_BE_COPIED_ON_INFORMATION_IMPACTING_THE_COMPANY_BUT_WILL_BE_LEFT_OFF_ON_COMMUNICATION_THAT_DOES_NOT_IMPACT_THE_COMPANY": "A_COMPANY_REPRESENTATIVE_WILL_ONLY_BE_COPIED_ON_INFORMATION_IMPACTING_THE_COMPANY_BUT_WILL_BE_LEFT_OFF_ON_COMMUNICATION_THAT_DOES_NOT_IMPACT_THE_COMPANY"
};

const PaymentPreference = {
  "CHECK": "CHECK",
  "ACH": "ACH",
  "CREDIT_CARD": "CREDIT_CARD"
};

const CompanyEmployee = {
  "COMPANY": "COMPANY",
  "EMPLOYEE": "EMPLOYEE"
};

const PermissionReleasePetitionsRfe = {
  "TRUE": "TRUE",
  "YES_WITH_COMPANY_PERMISSION": "YES_WITH_COMPANY_PERMISSION",
  "FALSE": "FALSE"
};

const PreferredShippingSpeedForDocuments = {
  "OVERNIGHT": "OVERNIGHT",
  "TWO_DAYS": "TWO_DAYS",
  "SAVER": "SAVER"
};

const ShippingPaymentPreference = {
  "FEDEX": "FEDEX",
  "UPS": "UPS",
  "MH": "MH"
};

const UtilizePremiumProcessingService = {
  "ALWAYS_PAID": "ALWAYS_PAID",
  "CASE_BY_CASE": "CASE_BY_CASE",
  "PAID_BY_EMPLOYEE": "PAID_BY_EMPLOYEE"
};

const TechnologyReleaseLicenseRequirement = {
  "REQUIRED": "REQUIRED",
  "NON_REQUIRED": "NON_REQUIRED"
};

const ReadState = {
  "READ": "READ",
  "UNREAD": "UNREAD"
};

const PartnerPosition = {
  "PRINCIPAL": "PRINCIPAL",
  "SPECIALIST": "SPECIALIST"
};

const Role = {
  "TEAMMEMBER": "TEAMMEMBER",
  "ADMIN": "ADMIN",
  "FOREIGNNATIONAL": "FOREIGNNATIONAL",
  "EMPLOYER": "EMPLOYER"
};

const SpecializationCountry = {
  "US": "US",
  "CANADA": "CANADA",
  "UK": "UK",
  "AUSTRALIA": "AUSTRALIA",
  "CHINA": "CHINA",
  "MEXICO": "MEXICO"
};

const TaskAssignmentRole = {
  "CASE_MANAGER": "CASE_MANAGER",
  "ATTORNEY": "ATTORNEY",
  "HIRING_MANAGER": "HIRING_MANAGER",
  "LEGAL_ASSISTANT": "LEGAL_ASSISTANT",
  "FOREIGN_NATIONAL": "FOREIGN_NATIONAL"
};

const FileCategory = {
  "COMPANY": "COMPANY",
  "SIGNATURE_PAGES": "SIGNATURE_PAGES",
  "EDUCATION": "EDUCATION",
  "EMPLOYMENT": "EMPLOYMENT",
  "EXPERIENCE_LETTER": "EXPERIENCE_LETTER",
  "PERSONAL_IDENTIFICATION": "PERSONAL_IDENTIFICATION",
  "US_IMMIGRATION": "US_IMMIGRATION",
  "FORMS_LETTERS": "FORMS_LETTERS",
  "APPLICATIONS_APPROVALS": "APPLICATIONS_APPROVALS",
  "GOVERNMENT_NOTICES": "GOVERNMENT_NOTICES",
  "OTHER": "OTHER",
  "PERM_RECRUITMENT": "PERM_RECRUITMENT"
};

const { CaseNote, Employer, EmployerAssignment, Company, ForeignNational, FamilyRelationship, JobDescription, FileData, TeamMember, AttorneyAssignment, ParalegalAssignment, Case, CaseContributor, ProcessRequest, Task, Comment, CaseFile, PreparedForm, Activity, EmployerAdminAssignment, InvoicingContact, PrimaryContact, SeniorContact, SignatoryContact, CompanyData, Notification, Firm, TaskTemplate, Picture, S3Object, Thumbnail, LoginStatus, NationalOnboardingSections, StreetAddress, ImmigrationStatus, J1J2, BooleanTwoPart, I140, CriminalHistory, BooleanExplain, ProcessRequestEmployeeData, ProcessRequestEmploymentData, ProcessRequestLocation, Money, FileRequirement, CasePhaseRequirement, CompletedCaseMilestone, PreparedFormTemplate, ShippingPreference, KnowledgeCenterLink, Shortcut, Address } = initSchema(schema);

export {
  CaseNote,
  Employer,
  EmployerAssignment,
  Company,
  ForeignNational,
  FamilyRelationship,
  JobDescription,
  FileData,
  TeamMember,
  AttorneyAssignment,
  ParalegalAssignment,
  Case,
  CaseContributor,
  ProcessRequest,
  Task,
  Comment,
  CaseFile,
  PreparedForm,
  Activity,
  EmployerAdminAssignment,
  InvoicingContact,
  PrimaryContact,
  SeniorContact,
  SignatoryContact,
  CompanyData,
  Notification,
  Firm,
  TaskTemplate,
  UserGroup,
  ArchivedState,
  S3Level,
  UserStatus,
  PersonType,
  CompanyType,
  CompanyAddressType,
  UnitType,
  StateCode,
  CountryCode,
  MaritalStatus,
  FamilyRelationshipType,
  VisaStatus,
  EmploymentBasedCategory,
  JobDescriptionType,
  Degree,
  FileType,
  Position,
  CaseState,
  ProcessRequestLocationType,
  Currency,
  VisaSubCategory,
  ProcessRequestState,
  TaskCategory,
  TaskState,
  CasePhase,
  CaseMilestone,
  PreparedFormState,
  ActivityType,
  PassportGender,
  ExpenseDependentPetitions,
  EducationEvaluation,
  EmployeesEmailContactDirectly,
  PaymentPreference,
  CompanyEmployee,
  PermissionReleasePetitionsRfe,
  PreferredShippingSpeedForDocuments,
  ShippingPaymentPreference,
  UtilizePremiumProcessingService,
  TechnologyReleaseLicenseRequirement,
  ReadState,
  PartnerPosition,
  Role,
  SpecializationCountry,
  TaskAssignmentRole,
  FileCategory,
  Picture,
  S3Object,
  Thumbnail,
  LoginStatus,
  NationalOnboardingSections,
  StreetAddress,
  ImmigrationStatus,
  J1J2,
  BooleanTwoPart,
  I140,
  CriminalHistory,
  BooleanExplain,
  ProcessRequestEmployeeData,
  ProcessRequestEmploymentData,
  ProcessRequestLocation,
  Money,
  FileRequirement,
  CasePhaseRequirement,
  CompletedCaseMilestone,
  PreparedFormTemplate,
  ShippingPreference,
  KnowledgeCenterLink,
  Shortcut,
  Address
};